/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { motion } from "framer-motion";
import ChapterHeading from "./ChapterHeading";
import { fadeUp, staggerParent, viewportOnce } from "../../lib/motion";

const stats = [
  { value: "1er", label: "réseau moderne de proximité", sub: "d'Afrique francophone.", color: "#ED1C24" },
  { value: "7j/7", label: "toujours près de vous", sub: "à deux pas de chez vous.", color: "#68AD45" },
  { value: "100%", label: "produits traçables", sub: "origine & fraîcheur vérifiées.", color: "#524FA1" },
];

export default function LeReseau() {
  return (
    <section
      id="le-reseau"
      data-testid="le-reseau-section"
      className="relative bg-diallo-charcoal text-white py-24 md:py-32 overflow-hidden"
    >
      {/* soft glow */}
      <div className="pointer-events-none absolute -top-24 right-0 h-96 w-96 rounded-full bg-diallo-red/20 blur-3xl" />
      <div className="mx-auto max-w-7xl px-5 md:px-8 relative z-10">
        <div className="max-w-4xl">
          <ChapterHeading
            number="06"
            kicker="Le réseau"
            tone="light"
            title={
              <>
                En Côte d'Ivoire d'abord.{" "}
                <span className="text-diallo-red">Puis toute l'Afrique francophone.</span>
              </>
            }
          />
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="mt-6 text-lg md:text-xl leading-relaxed text-white/75 max-w-3xl"
          >
            Nous construisons un réseau d'entrepreneurs, pas une chaîne de magasins. Chaque boutique reste
            celle de son propriétaire — unie aux autres par la même marque, connectée par la même plateforme.
            Plus fortes ensemble.
          </motion.p>
        </div>

        <motion.div
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-6"
        >
          {stats.map((s) => (
            <motion.div
              key={s.label}
              variants={fadeUp}
              data-testid={`reseau-stat-${s.value}`}
              className="rounded-3xl bg-white/[0.04] border border-white/10 p-8 transition-colors duration-300 hover:bg-white/[0.07]"
            >
              <div
                className="font-display font-extrabold text-6xl lg:text-7xl leading-none whitespace-nowrap"
                style={{ color: s.color }}
              >
                {s.value}
              </div>
              <div className="mt-4 font-display font-semibold text-xl">{s.label}</div>
              <p className="mt-1 text-white/60">{s.sub}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.p
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mt-16 font-display italic text-2xl md:text-3xl text-white/90"
        >
          Un réseau d'entrepreneurs. Pas une chaîne de magasins.
        </motion.p>
      </div>
    </section>
  );
}
